import { useCallback, useMemo } from 'react'
import { CellTitle, CellValueArea, FormCell, CellPropsBase } from '.'
import { DateTermV2 } from '../../../../../domain/value-object/DateTermV2'
import { DateInput } from '../../../../components/inputs/DatePicker'
import { RangeDivider, RangeInputWrapper } from './RangeCellLayout'

type DateTermCellProps = {
  value: DateTermV2 | undefined
  onChange?: (v: DateTermV2 | undefined) => void
} & CellPropsBase

export const DateTermCell = ({
  value,
  onChange,
  cellWidth,
  label,
  help,
  editable = true,
  required,
  edited,
  validationErrors,
}: DateTermCellProps) => {
  const { startDate, endDate } = useMemo(() => {
    if (!value) {
      return {
        startDate: undefined,
        endDate: undefined,
      }
    }
    return value
  }, [value])
  const onChangeStartDate = useCallback(
    (v: Date | undefined) => {
      onChange &&
        onChange({
          startDate: v,
          endDate,
        })
    },
    [endDate, onChange]
  )
  const onChangeEndDate = useCallback(
    (v: Date | undefined) => {
      onChange &&
        onChange({
          startDate,
          endDate: v,
        })
    },
    [startDate, onChange]
  )
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <RangeInputWrapper>
          <DateInput
            editable={editable}
            value={startDate}
            onChange={onChangeStartDate}
          />
        </RangeInputWrapper>
        <RangeDivider />
        <RangeInputWrapper>
          <DateInput
            editable={editable}
            value={endDate}
            onChange={onChangeEndDate}
          />
        </RangeInputWrapper>
      </CellValueArea>
    </FormCell>
  )
}
